import { Component, OnInit, ViewChild, Input } from '@angular/core'
import {
  isSomething,
  PromptDialogService,
  Toaster,
  localeCompareSort,
  ActionFailed,
  isEmptyTable,
} from '@tokeet-frontend/tv3-platform'
import { BdcContentV2Service, BdcRatePlanResponse } from '@tokeet-frontend/channel-content'
import { filter, finalize, switchMap, take } from 'rxjs/operators'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'

@Component({
  selector: 'app-bdc-property-rates',
  templateUrl: './bdc-property-rates.component.html',
  styleUrls: ['./bdc-property-rates.component.scss'],
})
export class BdcPropertyRatesComponent implements OnInit {
  @Input() propertyId: number

  @ViewChild('paginator', { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort

  dataSource = new MatTableDataSource<BdcRatePlanResponse>([])
  displayedColumns = ['name', 'id', 'active', 'propertyId', 'propertyName', 'edit']
  isLoading = false
  isEmptyTable$ = isEmptyTable(this.dataSource)

  constructor(
    private toaster: Toaster,
    private store: Store<any>,
    private contentService: BdcContentV2Service,
    private promptDialog: PromptDialogService
  ) {}

  ngOnInit() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortData = localeCompareSort
    this.onRefresh()
  }

  onRefresh() {
    this.isLoading = true
    this.contentService
      .getPropertyRatePlans(this.propertyId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.dataSource.data = data
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onStatusChange(rate: BdcRatePlanResponse, status: boolean) {
    this.contentService
      .updatePropertyRatePlan(this.propertyId, rate.id, {
        active: status ? 1 : 0,
      })
      .subscribe(
        (res) => {
          this.toaster.success($localize`Rate Status updated successfully.`)
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
  onSearch(term: string) {
    this.dataSource.filter = (term + '').trim().toLowerCase()
  }

  onEdit(rate: BdcRatePlanResponse) {
    this.promptDialog
      .open({
        title: $localize`Enter Rate Name`,
        buttonIcon: 'cs-icon cs-icon-save',
        buttonText: $localize`Update`,
        defaultValue: rate.name,
        placeholder: $localize`Rate Name`,
      })
      .pipe(
        take(1),
        filter(isSomething),
        switchMap((name) =>
          this.contentService.updatePropertyRatePlan(this.propertyId, rate.id, {
            name,
          })
        )
      )
      .subscribe(
        (res) => {
          this.toaster.success($localize`Rate Name updated successfully.`)
          this.onRefresh()
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onAdd() {
    this.promptDialog
      .open({
        title: $localize`Enter Rate Name`,
        buttonIcon: 'cs-icon cs-icon-save',
        buttonText: $localize`Add`,
        placeholder: $localize`Rate Name`,
      })
      .pipe(
        take(1),
        filter(isSomething),
        switchMap((name) =>
          this.contentService.createPropertyRatePlans(this.propertyId, {
            name,
          })
        )
      )
      .subscribe(
        (res) => {
          this.toaster.success($localize`Rate added successfully.`)
          this.onRefresh()
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
}
